import { useCallback, useEffect, useRef, useState } from "react";

const useHorizontalScroll = (watch?: unknown) => {
  const ref = useRef<HTMLDivElement>(null);
  const [needsScroll, setNeedsScroll] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const update = useCallback(() => {
    const node = ref.current;
    if (!node) return;
    const max = node.scrollWidth - node.clientWidth;
    const overflow = max > 1;
    setNeedsScroll(overflow);
    setCanScrollLeft(overflow && node.scrollLeft > 1);
    setCanScrollRight(overflow && max - node.scrollLeft > 1);
  }, []);

  const scroll = useCallback((direction: -1 | 1) => {
    const node = ref.current;
    if (!node) return;
    node.scrollBy({
      left: direction * Math.max(node.clientWidth * 0.6, 160),
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    update();
    const observer = new ResizeObserver(update);
    observer.observe(node);
    node.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      observer.disconnect();
      node.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [watch, update]);

  return { ref, needsScroll, canScrollLeft, canScrollRight, scroll };
};

export default useHorizontalScroll;
